export default __webpack_public_path__ + "static/media/china-unicom-china.1f3d2845.png";